import { render, staticRenderFns } from "./VamosPaLaCalleActividad.vue?vue&type=template&id=f383513e&scoped=true"
import script from "./VamosPaLaCalleActividad.vue?vue&type=script&setup=true&lang=js"
export * from "./VamosPaLaCalleActividad.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f383513e",
  null
  
)

export default component.exports